import type { ReactNode } from 'react';
import { cn } from '@/shared/lib/cn';

export interface MetaItem {
  /** Ikona przed etykieta. */
  icon?: ReactNode;
  label: ReactNode;
  value: ReactNode;
}

export interface MetaBarProps {
  items: readonly MetaItem[];
  className?: string;
}

/**
 * Poziomy pasek metadanych — „Runda / Postęp turnieju / Zawodnicy / Korty / Termin”
 * z naglowka centrum turnieju.
 *
 * Na waskich ekranach zawija sie do siatki zamiast przewijac poziomo.
 */
export function MetaBar({ items, className }: MetaBarProps) {
  return (
    <dl className={cn('grid gap-x-8 gap-y-4 sm:grid-cols-2 lg:flex lg:flex-wrap', className)}>
      {items.map((item, index) => (
        <div key={index} className="flex min-w-0 items-start gap-2.5">
          {item.icon && (
            <span className="text-fg-subtle mt-0.5 shrink-0 [&_svg]:size-4">{item.icon}</span>
          )}
          <div className="min-w-0">
            <dt className="text-fg-muted text-xs">{item.label}</dt>
            <dd className="text-fg-strong truncate text-sm font-semibold">{item.value}</dd>
          </div>
        </div>
      ))}
    </dl>
  );
}
